import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import PropType from "prop-types";
import logo from "../../assets/images/logo";
import musicLogo from "../../assets/images/musicLogo";
import home from "../../assets/images/menu/home.png";
import homePurple from "../../assets/images/menu/home-purple.png";
import creditzGrey from "../../assets/images/menu/creditz-grey.png";
import find from "../../assets/images/menu/find.png";
import findColor from "../../assets/images/menu/find-color.png";
import messages from "../../assets/images/menu/messages.png";
import messagesColor from "../../assets/images/menu/message-purple.png";
import styles from "./style.module.scss";
import settings from "../../assets/images/menu/settings.png";
import settingsPurple from "../../assets/images/menu/settings-purple.png";
import friends from "../../assets/images/menu/friends.png";
import friendsColor from "../../assets/images/menu/people-color.png";
import searchIcon from "../../assets/images/menu/searchIcon.png";

const TopBar = ({ history, location }) => {
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  return (
    <header
      className={styles.header}
      style={location.pathname === "/find" ? { minWidth: 1336 } : {}}
    >
      <div className={styles.headersElemets}>
        <div className={styles.logoContainer}>
          <img src={logo()} alt="logo" onClick={() => history.push("/")} />
        </div>
        <div className={styles.topBarElements}>
          <div className={styles.elements}>
            <div className={styles.item} onClick={() => history.push("/")}>
              <img
                src={location.pathname === `/home` ? homePurple : home}
                alt="logo"
                style={{ width: 32, height: 32 }}
              />
              <div
                style={
                  location.pathname === `/home`
                    ? { fontWeight: 700, color: "#7302C9" }
                    : {}
                }
              >
                Home
              </div>
              {location.pathname === `/home` && (
                <div className={styles.selected} />
              )}
            </div>
            <div
              className={styles.thumb}
              onClick={() => history.push("/profile")}
            >
              <div
                style={{
                  backgroundImage: `url(${currentUser?.profileImageUrl})`,
                }}
                className={styles.imageContainer}
              />
              <div
                style={
                  location.pathname === `/profile`
                    ? { fontWeight: 700, color: "#7302C9" }
                    : {}
                }
              >
                Profile
              </div>
              {location.pathname === `/profile` && (
                <div className={styles.selected} style={{ bottom: 2 }} />
              )}
            </div>
            <div
              className={styles.item}
              onClick={() => history.push("/creditz")}
            >
              <img
                src={
                  location.pathname === `/creditz` ? musicLogo() : creditzGrey
                }
                alt="musicLogo"
                style={{ width: 31, height: 32 }}
              />
              <div
                style={
                  location.pathname === `/creditz`
                    ? { fontWeight: 700, color: "#7302C9" }
                    : {}
                }
              >
                Creditz
              </div>
              {location.pathname === `/creditz` && (
                <div className={styles.selected} />
              )}
            </div>
            <div className={styles.item} onClick={() => history.push("/find")}>
              <img
                src={location.pathname === `/find` ? findColor : find}
                alt="userImage"
                style={
                  location.pathname === `/find`
                    ? { width: 35, height: 27, margin: 3 }
                    : { width: 35, height: 27 }
                }
              />
              <div
                style={
                  location.pathname === `/find`
                    ? { fontWeight: 700, color: "#7302C9", marginTop: 3 }
                    : { marginTop: 3 }
                }
              >
                Find
              </div>
              {location.pathname === `/find` && (
                <div className={styles.selected} />
              )}
            </div>
            <div
              className={styles.item}
              onClick={() => history.push("/messages")}
            >
              <img
                src={
                  location.pathname === `/messages` ? messagesColor : messages
                }
                alt="userImage"
                style={
                  location.pathname === `/messages`
                    ? { width: 33, height: 28 }
                    : { width: 29, height: 28 }
                }
              />
              <div
                style={
                  location.pathname === `/messages`
                    ? { fontWeight: 700, color: "#7302C9", marginTop: 3 }
                    : { marginTop: 3 }
                }
              >
                Messages
              </div>
              {location.pathname === `/messages` && (
                <div className={styles.selected} />
              )}
            </div>
          </div>
          <div className={styles.searchContainer}>
            <div className={styles.inputContainer}>
              <img
                src={searchIcon}
                alt="logo"
                style={{ width: 18, height: 18 }}
              />
              <input placeholder="search" />
            </div>
            <div className={styles.item}>
              <img
                src={
                  location.pathname === `/creditz/connections`
                    ? friendsColor
                    : friends
                }
                alt="logo"
                onClick={() => history.push("/creditz/connections")}
                style={
                  location.pathname === `/creditz/connections`
                    ? {
                        width: 30,
                        height: 37,
                        cursor: "pointer",
                        top: -3,
                        position: "relative",
                      }
                    : { width: 23, height: 20, cursor: "pointer" }
                }
              />
            </div>
            <div className={styles.item}>
              <img
                src={
                  location.pathname === `/settings` ? settingsPurple : settings
                }
                alt="logo"
                style={
                  location.pathname === `/settings`
                    ? { width: 28, height: 28 }
                    : { width: 18, height: 18 }
                }
                onClick={() => history.push("/settings")}
              />
            </div>
          </div>
        </div>
      </div>
      <hr />
    </header>
  );
};

TopBar.propTypes = {
  history: PropType.object,
  location: PropType.object,
};

export default withRouter(TopBar);
